import { layoutUnisonVoices } from "../../../../../src/lib/audio";

/** Visual representation of unison voices: spread, level, detune. */
export function UnisonVoiceVisualizer({
  voices,
  detune,
  spread,
  edgeDecay,
}: {
  voices: number;
  detune: number;
  spread: number;
  edgeDecay: number;
}) {
  const layout = layoutUnisonVoices(voices, detune, spread, edgeDecay);
  return (
    <div
      className="relative my-1 h-14 overflow-hidden rounded border border-lab-line bg-[#0c1016] px-2 py-1"
      title="Unison voices — height = level, spacing = spread, tint = detune"
    >
      {/* Center reference */}
      <div className="pointer-events-none absolute inset-y-1 left-1/2 w-px -translate-x-1/2 bg-white/10" />
      {layout.map((v, i) => {
        const height = Math.max(8, v.level * 40);
        // pan is −spread..+spread (−1..+1 at full spread) → % from center
        const leftPct = 50 + v.pan * 46;
        const hue = 200 + v.detuneCents * 2;
        return (
          <div
            key={i}
            className="absolute bottom-1 w-[3px] -translate-x-1/2 rounded-sm"
            style={{
              height,
              left: `${leftPct}%`,
              background: `hsl(${hue} 55% 58%)`,
              opacity: 0.55 + v.level * 0.45,
            }}
          />
        );
      })}
    </div>
  );
}
